import React from "react";
import { useSelector } from "react-redux";
import { getModals, getModalsLoading } from "selectors/commonSelectors";

// General
import MediaPickerModal from "components/MediaPicker/modals/MediaPickerModal";
import PlansModal from "features/plans-modal";

// Posts
import PreviewPostModal from "components/Posts/modals/PreviewPostModal";
import ImportIgPostsModal from "components/ImportIgPostsModal/index.js";

// Sked Url
import SkedUrlModal from "components/Posts/modals/SkedUrlModal";

// External Collab
import ExternalCollabModal from "components/Posts/modals/ExternalCollabModal";
import ExternalPermissionModal from "external-review/components/ExternalPermissionModal";

// Media Library
import NewCollectionModal from "components/MediaLibrary/modals/NewCollectionModal";
import ConfirmModal from "ui/modals/ConfirmModal";
import EditCollectionAssetModal from "components/MediaLibrary/modals/EditCollectionAssetModal";
import BulkAssetTagsModal from "components/MediaLibrary/modals/BulkAssetTagsModal";
import BulkMoveAssetsModal from "components/MediaLibrary/modals/BulkMoveAssetsModal";
import AddToCollectionModal from "components/MediaLibrary/modals/AddToCollectionModal";
import ViewHashtagFeedItemModal from "components/MediaLibrary/modals/ViewHashtagFeedItemModal";
import DuplicateAssetsModal from "components/MediaLibrary/modals/DuplicateAssetsModal";

// Insights
import { AddInsightsReportsModal } from "features/plans-modal/dialogs/insights-reports";

import { Modals } from "libs/modals";

import { UpsellModal } from "features/upsell/upsell-modal";

const MODAL_COMPONENTS = {
  ADD_COLLECTION: NewCollectionModal,
  CONFIRM_MODAL: ConfirmModal,
  EDIT_COLLECTION_ASSET: EditCollectionAssetModal,
  BULK_ASSET_TAGS: BulkAssetTagsModal,
  BULK_MOVE_ASSETS: BulkMoveAssetsModal,
  DUPLICATE_ASSETS: DuplicateAssetsModal,
  ADD_TO_COLLECTION: AddToCollectionModal,
  VIEW_HASHTAG_FEED_ITEM: ViewHashtagFeedItemModal,
  PREVIEW_POST: PreviewPostModal,
  SKED_URL: SkedUrlModal,
  EXTERNAL_COLLAB: ExternalCollabModal,
  EXTERNAL_PERMISSION: ExternalPermissionModal,
  ADD_INSIGHTS_REPORTS: AddInsightsReportsModal,
  MEDIA_PICKER: MediaPickerModal,
  IMPORT_IG_POSTS: ImportIgPostsModal,
  UPGRADE_PLAN: PlansModal,
  UPSELL: UpsellModal,
};

const ModalRoot = () => {
  const modals = useSelector(getModals) ?? [];
  const loading = useSelector(getModalsLoading);

  return (
    <>
      {modals.map((modalInstance) => {
        const { modalType, modalProps } = modalInstance;
        const SpecificModal = MODAL_COMPONENTS[modalType];
        if (SpecificModal) {
          return (
            <SpecificModal key={modalType} {...modalProps} loading={loading} />
          );
        }
      })}

      <Modals />
    </>
  );
};

export default ModalRoot;
